<!-- MyMenu.vue -->
<template>
  <v-menu >
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" class="w-100">
        Configure {{ typeLabel }} card type
      </v-btn>
    </template>
    <v-list density="compact" width="200">
      <v-list-item style="user-select: none;">
        <b><small>Select {{ typeLabel }} card type:</small></b>
      </v-list-item>
      <v-list-item v-for="item in menuItems" :key="item.id" @click="selectItem(item)">
        <v-list-item-title>
          <v-avatar :color="item?.color?.rgb || 'gray'" size="18" class="card-type-color mr-2"></v-avatar>
          <span class="card-type-title">{{ item.title }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="createNewCardType()">
        <v-list-item-title class="no-color">
          Create new card type
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import cardTypesApi from '@/api/cardTypesApi'
import { DomainModelRole } from '@/constants/cardTypes'

export default {
  props: {
    cardTypes: Array,
    type: {
      type: String,
      default: null
    }
  },

  computed: {
    typeLabel () {
      switch (this.type) {
        case DomainModelRole.COMMAND:
          return 'Command'
        case DomainModelRole.READ_MODEL:
          return 'Read Model'
        case DomainModelRole.AGGREGATE_ROOT:
          return 'Aggregate Root'
        case DomainModelRole.DOMAIN_EVENT:
          return 'Domain Event'
        default:
          return 'Default'
      }
    },
    menuItems () {
      if (!this.cardTypes) return []
      return this.cardTypes.filter((item) => !item.domainModelRole)
    }
  },

  methods: {
    async selectItem (item) {
      const newItem = JSON.parse(JSON.stringify(item))

      switch (this.type) {
        case DomainModelRole.COMMAND:
          newItem.domainModelRole = DomainModelRole.COMMAND
          break
        case DomainModelRole.READ_MODEL:
          newItem.domainModelRole = DomainModelRole.READ_MODEL
          break
        case DomainModelRole.AGGREGATE_ROOT:
          newItem.domainModelRole = DomainModelRole.AGGREGATE_ROOT
          break
        case DomainModelRole.DOMAIN_EVENT:
          newItem.domainModelRole = DomainModelRole.DOMAIN_EVENT
          break
        default:
          newItem.domainModelRole = null
          newItem.defaultType = true
      }

      await cardTypesApi.updateCardType(this.$route.params.id, newItem)
      await this.$store.dispatch('workflow/refreshCardTypes', { input: { workflowId: this.$route.params.id } })
    },

    createNewCardType () {
      this.$store.dispatch('workflow/openWorkflowSettings')
    }
  }
}
</script>

<style scoped>
.card-type-title {
  vertical-align: middle;
}

.no-color {
  margin-left: 26px;
}
</style>
